<template>
  <v-container fluid style="height: 100%; padding-bottom: 125px">
    <v-col cols="12" align="left">
        <h3 style="font-weight: 500;color:#696969;">
          {{ $t("configTracking").toUpperCase() }}
        </h3>
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <v-data-table
        :headers="headersConfigAT"
        :items="contentConfig"
        item-key="MovilId"
        class="elevation-1"
        :search="search"
        :no-data-text="$t('noResults')"
        :loading="loadingTableInConfigProgress"
        :loading-text="$t('loadingTextForTable')"
        hide-default-footer
      >
        <template v-slot:top="{ item }">
          <v-card elevation="0" class="text-start">
            <v-card-title>
              <v-icon
                :color="colorTheme"
                class="pr-3"
              >
              mdi-file-upload-outline
              </v-icon>
              <span class="text-subtitle-1 font-weight-bold" >PLANTILLA 1</span>
            </v-card-title>
            <v-card-text>
              <v-container pa-0 ma-0 fluid>
                <v-row no-gutters align="center" class="pl-3">
                  <v-col sm="12" lg="2" md="6" xs="12">
                    <v-card flat>
                      <v-row
                        no-gutters
                      >
                      <p><span style="font-weight: bold;"> {{ $t("applicationDate") }}:</span> 01/01/2022 12:59</p>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col sm="12" lg="2" md="6" xs="12">
                    <v-card flat>
                      <v-row
                        no-gutters
                      >
                      <p><span style="font-weight: bold;">{{ $t("timeElapsedInConfig") }}:</span> 01 H, 05 m</p>
                      </v-row>
                    </v-card>
                  </v-col>
                    
                    <v-col sm="12" lg="2" md="6" xs="12">
                      <v-card flat>
                      <v-row
                        no-gutters
                      >
                      <p><span style="font-weight: bold;">{{ $t("statusT") }}:</span> {{ $t("configuring") }}</p>
                      </v-row>
                    </v-card>
                    </v-col>
                    
                    <v-col sm="12" lg="2" md="6" xs="12">
                      <v-card flat>
                      <v-row
                        no-gutters
                      >
                      <p><span style="font-weight: bold;">{{ $t("vehicles") }}:</span> 2/10</p>
                      </v-row>
                    </v-card>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col lg="2" md="6" xs="12" sm="12">
                      <v-text-field
                        solo
                        :label="$t('search')"
                        append-icon="mdi-magnify"
                        single-line
                        v-model="search"
                        :color="colorTheme"
                      ></v-text-field>
                    </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:item.icon="{ item }">
          <v-btn
            icon
            color="#88AD59"
            loading
            v-if="item.Status == status2"
          >
          <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-icon color="#88AD59" v-else-if="item.Status == status">mdi-check</v-icon>
          <v-icon color="red" v-else>mdi-close</v-icon>
        </template>
        <template v-slot:body.append>
          <div style="height:59px;"></div>
        </template>
      </v-data-table>
      </v-col>
      <v-row justify="end">
        <v-col sm="4" md="3" lg="2" cols="12" style="padding-bottom: 20px">
          <v-btn
        style="width: 100%; margin: 0"
        large
        :color="colorTheme"
        class="white--text"
        v-on:click="finished()"
        disabled
        >{{ $t("finished").toUpperCase() }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
export default {
  name: "configurationProgress",
  data: () => ({
    search: '',
    status: i18n.t("configured"),
    status2: i18n.t("configuring"),
  }),
  created() {
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("setPageHeader", [
      this.$t("parametersConfig").toUpperCase(),
      this.$t("configProgress").toUpperCase(),
      "",
      "",
      true
    ]);
  },
  mounted() {
    this.$store.dispatch("configProgress");
  },
  computed: {
    ...mapState([
      "colorTheme",
      "headersConfigAT",
      "contentConfig",
      "loadingTableInConfigProgress"
    ]),
  },
  methods: {
    finished() {

    }
  }
};
</script>

<style></style>